import { Component, OnInit } from '@angular/core';
import { EMPTY } from 'rxjs';

@Component({
  selector: 'app-country-selection',
  templateUrl: './country-selection.component.html',
  styleUrls: ['./country-selection.component.scss'],
})
export class CountrySelectionComponent implements OnInit {
  public creditType!: string;
  constructor() {
    EMPTY;
  }

  ngOnInit(): void {
    this.creditType = sessionStorage.getItem('creditType')!;
  }
}
